import React, { Fragment } from "react";

import "./CUDButtons.css";
import "../../styles/uikit.css";
import "../../styles/font-awesome-4.7.0/css/font-awesome.min.css";
import Button from "../../components/Button/Button";

class CUDButtons extends React.Component {
  constructor(props) {
    super(props);
    this.toggleClass = this.toggleClass.bind(this);
      this.state = { active: true };
  }

  toggleClass() {
    this.setState({ active: false });
  }

  render() {
    return (
      <Fragment>
        <div className="mn-content-buttons__container">          
          <div className="mn-content-buttons__title">
            عملیات بر روی گروه {this.props.categoryName}:
          </div>
          <Button
            design="next"
            mode={this.state.active ? "" : "disabled"}
            type="submit"
            onClick={() => {
              this.toggleClass();
              this.props.onAddHandler();
            }}
          >
            درج زیر گروه
          </Button>
          
            <Button
              design="edit"
              mode={this.state.active ? "" : "disabled"}
              type="submit"
              onClick={() => {
                this.toggleClass();
                this.props.onEditHandler();
              }}
            >
              ویرایش گروه
            </Button>
          
            <Button
              design="danger"
              mode={this.state.active ? "" : "disabled"}
              type="submit"
              onClick={() => {
                this.props.onDeleteHandler();
              }}
            >
              حذف گروه
            </Button>
          
        </div>
      </Fragment>
    );
  }
}

export default CUDButtons;
